import React from 'react'
import { Card, Spinner } from 'react-bootstrap'
import { Bar } from 'react-chartjs-2'
import { FaTachometerAlt } from 'react-icons/fa'
import { SectionTitle, DetailCard, DetailHeader, ChartContainer } from '../styles'

interface ModelPerformanceData {
  labels: string[]
  datasets: {
    label: string
    data: number[]
    backgroundColor: string
    borderColor: string
    borderWidth: number
  }[]
}

interface ModelPerformanceOptions {
  responsive: boolean
  maintainAspectRatio: boolean
  scales: any
  plugins: any
}

interface ModelPerformanceSectionProps {
  loading: boolean
  chartData: ModelPerformanceData
  chartOptions: ModelPerformanceOptions
}

const ModelPerformanceSection: React.FC<ModelPerformanceSectionProps> = ({
  loading,
  chartData,
  chartOptions,
}) => {
  return (
    <>
      <SectionTitle>
        <FaTachometerAlt /> Model Performance Comparison
      </SectionTitle>
      <DetailCard style={{ height: '350px' }}>
        <DetailHeader>
          <h3>Model Metrics</h3>
        </DetailHeader>
        <Card.Body>
          <ChartContainer className="model-performance">
            {loading ? (
              <div className="loading-overlay">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Bar data={chartData} options={chartOptions} />
            )}
          </ChartContainer>
        </Card.Body>
      </DetailCard>
    </>
  )
}

export default ModelPerformanceSection
